export default "__VITE_ASSET__6bf983a0__"